export const mapUserProjectStats = (dto) => ({
    projectId: dto.projectId,
    projectName: dto.projectName,
    companyName: dto.companyName,
    totalWorkTime: dto.totalWorkTime,
    entries: Array.isArray(dto.entries) ? dto.entries.map(mapTimeEntry) : []
});

const mapTimeEntry = (dto) => ({
    id: dto.id,
    date: dto.date,
    projectId: dto.projectId,
    dayOfWeek: dto.dayOfWeek,
    startTime: dto.startTime,
    endTime: dto.endTime,
    workTime: dto.workTime,
    breakMinutes: dto.breakMinutes,
    travelMinutes: dto.travelMinutes,
    location: dto.location,
    activity: dto.activity,
    comment: dto.comment,
    projectName: dto.projectName,

})